var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "z-accordion",
    _vm._l(_vm.committeesData, function (committee, id) {
      return _c("z-accordion-item", {
        key: id,
        attrs: { id: committee.code },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [_c("span", [_vm._v(_vm._s(committee.name))])]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function () {
                return [
                  committee.previewText
                    ? _c("vue-raw", {
                        staticClass: "html-content u-bottom-margin--m",
                        domProps: { innerHTML: _vm._s(committee.previewText) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "committee__container row" },
                    _vm._l(committee.members, function (member, code) {
                      return _c(
                        "div",
                        {
                          key: code,
                          staticClass: "col-default-5 col-tablet-12",
                        },
                        [
                          _c("z-contact-card", {
                            staticClass: "u-bottom-margin--xs",
                            attrs: {
                              photo:
                                (member.previewPicture &&
                                  member.previewPicture.link) ||
                                "/images/people/_.jpeg",
                              title: member.name,
                              subtitle: member.position.value,
                              link:
                                "/" +
                                _vm.$root.lang +
                                "/company/governance/board-of-directors/" +
                                member.code +
                                "/",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row u-top-margin--s" }, [
                    _c(
                      "div",
                      { staticClass: "col-default-12" },
                      [
                        committee.files
                          ? _c(
                              "z-filelist",
                              { attrs: { size: "s" } },
                              [
                                _c(
                                  "z-filelist-item",
                                  {
                                    attrs: {
                                      icon: "file/" + committee.files.type,
                                      info: committee.files.size,
                                    },
                                  },
                                  [
                                    _c("z-link", {
                                      attrs: { href: committee.files.link },
                                      domProps: {
                                        innerHTML: _vm._s(committee.files.name),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }